import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { faEye } from '@fortawesome/free-solid-svg-icons'

import services from '../../../../services';

const Card = ({ usuario, permiteAlterar, permiteVisualizar }) => {

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Razão social:
            </div>
            <div className={styles.info}>
                {usuario.razaoSocial}
            </div>
            <div className={styles.title}>
                Nome Fantasia:
            </div>
            <div className={styles.info}>
                {usuario.nomeFantasia}
            </div>
            <div className={styles.title}>
                ID Parceiro:
            </div>
            <div className={styles.info}>
                {usuario.codigo}
            </div>
            <div className={styles.title}>
                CNPJ
            </div>
            <div className={styles.info}>
                {services.mask.cnpj(usuario.cnpj)}
            </div>
            <div className={styles.actionWrapper}>
                {usuario.status === "Ativo" ? (<div className={styles.andamento}>ATIVO</div>) : (<div className={styles.encerrado}>INATIVO</div>)}
                {
                    permiteAlterar && (
                        <button className={styles.editar} onClick={() => { history.push(`/parceiros/detalhes?parceiro=${usuario.parceiroId}`) }}>
                            Editar
                            <FontAwesomeIcon icon={faUpload} className={styles.icon} />
                        </button>)

                }
                {
                    permiteVisualizar && (
                        <button className={styles.visualizar} onClick={() => { history.push(`/parceiros/detalhes?parceiro=${usuario.parceiroId}`) }}>
                            Visualizar
                            <FontAwesomeIcon icon={faEye} className={styles.icon} />
                        </button>
                    )
                }

            </div>
        </div>
    )
}

export default Card